import React from 'react';
// import { X, Calendar, Star } from 'lucide-react';

interface InfoPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function DobPopup({ isOpen, onClose }: InfoPopupProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 dob-popup">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full mx-4 transform transition-all">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-2">
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
             </svg>
              <h3 className="text-lg font-semibold text-gray-800 flex-1">Why do we need your birth date for Trading?</h3>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 6 6 18"></path><path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
          
          <div className="space-y-3 text-gray-600">
            <div className="flex items-start space-x-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="w-6 h-6 text-blue-400" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path>
              </svg>
              <div className='flex-1'>
                <p className="font-medium text-gray-700 mb-1">Financial Cycle Analysis</p>
                <p className="text-sm">Your birth date helps determine lucky cycles, favorable timing for trading, and investment styles that suit you.</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"  className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
              </svg>
              <div className='flex-1'>
                <p className="font-medium text-gray-700 mb-1">Personal Trading Strategy</p>
                <p className="text-sm">From your birth date, we analyze your trading personality, risk tolerance, and provide suitable investment strategies.</p>
              </div>
            </div>
            
            <div className="bg-blue-50 rounded-lg p-3 mt-4">
              <p className="text-sm text-blue-800">
                <strong>Note:</strong> Your information is kept strictly confidential and is only used for numerological analysis in Trading.
              </p>
            </div>
          </div>
          
          <button
            onClick={onClose}
            className="w-full mt-6  bg-black text-white py-2.5 rounded-lg font-medium hover:scale-[1.02]"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
